// Batch 34 · B34-2 (owner default: the rule is kept) — why a final-analytical-review line is or is not highlighted, from the
// server's reason key (far.highlight): "above_pm_and_pct", "below_pm", "below_pct", "below_pm_and_pct", "no_prior_year".
// Shown as the row's tooltip; no reason (materiality not set) → no tooltip (the legend says why).
import { fmt, fmtPct, fill } from "@/components/far/FarParts";

export function highlightWhy(line, thresholds, t) {
  const key = line?.highlight_reason;
  if (!key) return "";
  const s = t(`far.why.${key}`);
  if (!s || s === `far.why.${key}`) return "";
  const th = thresholds || {};
  return fill(s, { mv: fmt(line.movement), mvPct: fmtPct(line.movement_pct), pm: fmt(th.pm), pct: th.pct ?? 20 });
}
